import React from 'react';

/** Screen-reader-only hint appended to links that open in a new tab. */
export function NewTabHint() {
  return <span className="sr-only" data-id="element-357" data-mp="2dud8z0yjum85"> (opens in a new tab)</span>;
}